import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-insurance-banner',
  imports: [RouterModule,TranslatePipe],
  templateUrl: './car-insurance-banner.component.html',
  styleUrl: './car-insurance-banner.component.scss'
})
export class CarInsuranceBannerComponent {
  scrollToForm() {
    const element = document.getElementById('leads-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
